import React, { useEffect, useMemo } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import DocArticle from '../dokumantasyon/DocArticle';
import {
  DOCS_TREE,
  docPathToUrl,
  findDoc,
  getDefaultDocPath,
} from '../dokumantasyon/docsRegistry';
import './DokumantasyonPage.css';

function DokumantasyonPage() {
  const navigate = useNavigate();
  const params = useParams();
  const splat = params['*'] || '';
  const parts = splat.split('/').filter(Boolean);
  const platformSlug = parts[0] || '';
  const roleSlug = parts[1] || '';
  const docSlug = parts[2] || '';

  const defaultPath = useMemo(() => getDefaultDocPath(), []);

  useEffect(() => {
    if (!platformSlug && defaultPath) {
      navigate(docPathToUrl(defaultPath), { replace: true });
    }
  }, [platformSlug, defaultPath, navigate]);

  const selectedDoc =
    platformSlug && roleSlug && docSlug
      ? findDoc(platformSlug, roleSlug, docSlug)
      : null;

  if (platformSlug && roleSlug && docSlug && !selectedDoc) {
    return <Navigate to="/dokumantasyon" replace />;
  }

  return (
    <div className="page-container dokumantasyon-page">
      <div className="page-header dokumantasyon-page__header">
        <h1>Dökümantasyon</h1>
      </div>

      <div className="dokumantasyon-page__layout">
        <aside className="dokumantasyon-page__tree" aria-label="Döküman ağacı">
          {DOCS_TREE.map((cat) => (
            <div key={cat.slug} className="docs-tree__category">
              <div className="docs-tree__category-title">{cat.title}</div>
              {cat.subcategories.map((sub) => (
                <div key={sub.slug} className="docs-tree__sub">
                  <div className="docs-tree__sub-title">{sub.title}</div>
                  <ul className="docs-tree__docs">
                    {sub.docs.map((doc) => {
                      const active =
                        platformSlug === cat.slug &&
                        roleSlug === sub.slug &&
                        docSlug === doc.slug;
                      return (
                        <li key={doc.slug}>
                          <Link
                            to={docPathToUrl({
                              platform: cat.slug,
                              role: sub.slug,
                              doc: doc.slug,
                            })}
                            className={`docs-tree__doc-link${active ? ' is-active' : ''}`}
                            aria-current={active ? 'page' : undefined}
                          >
                            {doc.title}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ))}
            </div>
          ))}
        </aside>

        <main className="dokumantasyon-page__content">
          {selectedDoc ? (
            <DocArticle doc={selectedDoc} />
          ) : (
            <div className="dokumantasyon-page__empty">
              Soldan bir döküman seçin.
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default DokumantasyonPage;
